import "./ErrorMsg.css";
import { Bounce, toast } from "react-toastify";

export const infoMsg = (message, headingName) => {
  toast.info(message, {
    position: "bottom-right",
    style: { backgroundColor: "#333333", color: "#fff" },
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Bounce,
  });
};

export const successMsg = (message, headingName) => {
  toast.success(message, {
    position: "bottom-right",
    autoClose: 4000,
    style: { backgroundColor: "#333333", color: "#fff" },
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
  });
};

export const errorMsg = (message, headingName) => {
  toast.error(message, {
    position: "bottom-right",
    autoClose: 4000,
    style: { backgroundColor: "#333333", color: "#fff" },
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
  });
};
